import useSaveSimulationPavillonInformationMutation from './useSaveSimulationPavillonInformationMutation';
import { useEffect, useState } from 'react';
import { useProcess } from '@fasstech/oip-starter-utils/app';
import { formatProject } from '@@viewHelpers/format.jsx';
import { useForm, useWatch } from 'react-hook-form';
import useSearchGranteeSalesRightsMutation from './useSearchGranteeSalesRightsMutation';
import { propEq } from 'ramda';

const useSimulationPavillonInformationForm = ({ project }) => {
  const form = useForm({
    mode: 'onChange',
    reValidateMode: 'onChange',
    defaultValues: formatProject(project)
  });

  const [loading, setLoading] = useState(false);
  const [unauthorizedModalMessage, setUnauthorizedModalMessage] = useState('');
  const [isUnauthorized, setIsUnauthorized] = useState(false);
  const { processHandlers, context } = useProcess();
  const { onFormSubmit } = useSaveSimulationPavillonInformationMutation();

  const { onFormSubmit: onSearchGranteeSalesRights } = useSearchGranteeSalesRightsMutation();

  const $onPrevClick = () => {
    processHandlers.onPrev({
      context: {
        projectId: context?.projectId
      }
    });
  };

  const grantees = useWatch({
    control: form.control,
    name: 'grantees',
    defaultValue: {}
  });

  useEffect(() => {
    setIsUnauthorized(false);
  }, [grantees]);

  const onSubmit = (values) => {
    if (loading) return;
    setLoading(true);
    onSearchGranteeSalesRights({ grantees: values.grantees }, (ok, err, data) => {
      if (ok && !err) {
        onFormSubmit(values, (ok, err) => {
          if (ok && !err) {
            processHandlers.onNext({
              context: {
                projectId: context?.projectId
              }
            });
          }
        });
      } else {
        if (err && propEq('code', 'SALES_UNAUTHORIZED', data)) {
          setUnauthorizedModalMessage(err);
          setIsUnauthorized(true);
        }
        setLoading(false);
      }
    });
  };

  return {
    $onPrevClick,
    onSubmit,
    form,
    unauthorizedModalMessage,
    setUnauthorizedModalMessage,
    isUnauthorized
  };
};

export default useSimulationPavillonInformationForm;
